export default "__VITE_ASSET__68ba02c7__"